import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { cn } from '../../lib/utils';

interface AccessButtonMountProps {
  accessButtonDisabled: boolean;
}

const AccessButtonMount: React.FC<AccessButtonMountProps> = ({ accessButtonDisabled }) => {
  return (
    <TooltipProvider>
      <div className="fixed bottom-6 left-6 z-50 pointer-events-auto">
        <div
          id="access-button-anchor"
          className={cn(
            'relative transition-all duration-200',
            accessButtonDisabled && 'opacity-50 cursor-not-allowed'
          )}
        />
        {accessButtonDisabled && (
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="absolute bottom-0 left-0 w-12 h-12 flex items-center justify-center rounded-full bg-destructive/10 backdrop-blur-sm pointer-events-auto cursor-not-allowed">
                <AlertCircle size={20} className="text-destructive" />
              </div>
            </TooltipTrigger>
            <TooltipContent side="right" className="max-w-xs">
              <p className="font-medium">Access Button temporarily unavailable</p>
              <p className="text-xs text-muted-foreground mt-1">
                Unable to connect to the Access Button service. Please try refreshing the page.
              </p>
            </TooltipContent>
          </Tooltip>
        )}
      </div>
    </TooltipProvider>
  );
};

export default AccessButtonMount;
